// Utilities

const exchangesMap = {
  doorbell: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  doorbot: /doorbell$|doorbell_v3$/,
  lpd: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  cam: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  jbox: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  floodlight: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  spotlight: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  intercom: /doorbell|lpd|cam|floodlight|spotlight|jbox|intercom/,
  chime: /chime/,
  other: /other|yard|solar/,
  yard: /other|yard|solar/,
  solar: /other|yard|solar/,
  base_station: /base_station/,
  alarm: /alarm/,
  beams: /beams/,
};

const replacementAllowedRegexp = function (kind) {
  let result;
  Object.keys(exchangesMap).forEach(function (item) {
    if (kind.match(item)) {
      result = exchangesMap[item];
      return;
    }
  });
  return result;
};

export { replacementAllowedRegexp };
